import { render, staticRenderFns } from "./create-credit-invoice-button.vue?vue&type=template&id=2c987750"
import script from "./create-credit-invoice-button.vue?vue&type=script&lang=js"
export * from "./create-credit-invoice-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports